/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = document.querySelectorAll('.social:not(.clipboard)');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
          event.preventDefault();
        });
      });
    }
  }
  customElements.define('social-share', SocialShare);
}


// Modifying default Share block — supports multiple share buttons
document.querySelectorAll('button.share-social').forEach((shareButton) => {
  const clipboardDiv = shareButton.nextElementSibling;
  if (!clipboardDiv || !clipboardDiv.classList.contains('social-share-with-clipbaord')) return;

  shareButton.addEventListener('click', (e) => {
    if (shareButton.classList.contains('selected')) {
      clipboardDiv.classList.remove('animated');
      shareButton.classList.remove('selected');
    } else {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          text: 'Check out this product!',
          url: window.location.href
        }).then(() => {
          console.log('Thanks for sharing!');
        }).catch((error) => {
          console.log('Sharing failed', error);
        });
        return;
      }
      clipboardDiv.classList.add('animated');
      shareButton.classList.add('selected');
    }
  });
});

window.addEventListener('click', (e) => {
  if (!(e.target.classList.contains('social-share-with-clipbaord') || e.target.classList.contains('share-social') || e.target.localName === 'input')) {
    document.querySelectorAll('.social-share-with-clipbaord.animated').forEach((el) => {
      el.classList.remove('animated');
    });
    document.querySelectorAll('button.share-social.selected').forEach((el) => {
      el.classList.remove('selected');
    });
  }
});